import { render } from "./Join.vue?vue&type=template&id=2bb68ac2"
import script from "./Join.vue?vue&type=script&lang=js"
export * from "./Join.vue?vue&type=script&lang=js"

import "./Join.vue?vue&type=style&index=0&id=2bb68ac2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__